$(document).ready(function() {
  $('.toggleList').each(function() {
    let isExpanded = false;
    const $button = $(this);
    const originalText = $button.text();
    const alternativeText = $button.data('alternative-text');
    const targetClass = $button.data('target-class');

    $button.on('click', function() {
      if (isExpanded) {
        $(targetClass).each(function(index) {
          if (index >= 4) {
            $(this).addClass('hidden__cards');
          }
        });
        $button.text(originalText);
      } else {
        $(targetClass + '.hidden__cards').each(function() {
          $(this).removeClass('hidden__cards');
        });
        $button.text(alternativeText);
      }
      isExpanded = !isExpanded;
    });
  });
});